
interface ObjectType {
    [key:string]: any;
}

export function isEmpty(value: any): boolean {
  if (value == null) return true; // Handles null/undefined
  if (typeof value === 'string' || Array.isArray(value)) return value.length === 0;
  if (typeof value === 'object') return Object.keys(value).length === 0;
  return false;
}

export function isNil(value:any) {
  return value == null || value == undefined;
}

export function flatten(obj: ObjectType, prefix: string = ''): ObjectType {
  const result: ObjectType = {};

  for(const [key, value] of Object.entries(obj)) {
    const newKey = prefix ? `${prefix}.${key}` : key;

    if (value && typeof value === "object" && !Array.isArray(value)) {
      // Recursively flatten nested objects
      Object.assign(result, flatten(value, newKey));
    } else {
      result[newKey] = value;
    }
  }

  return result;
}